import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import React, { useEffect } from "react"; // Adicionado useEffect
import images from "./index.js";
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

// Importações do AOS (Animate On Scroll)
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  // Inicialização do AOS
  useEffect(() => {
    AOS.init({
      duration: 800, // Duração da animação em milissegundos
      easing: "ease-in-out", // Curva de aceleração suave
      once: true, // Anima apenas uma vez ao rolar para baixo
      offset: 100, // Distância (em px) antes de disparar a animação
    });
  }, []);

  return (
    <div>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      {/* Link para FontAwesome movido para cá apenas como referência estrutural, o ideal é colocar no index.html */}
      <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css" rel="stylesheet" />

      <nav className="navbar navbar-expand-lg navbar-dark bg-gradient">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">
            <img src={images.logo} alt="NovaGenius Logo" className="logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item"><a className="nav-link active" href="#home">HOME</a></li>
              <li className="nav-item"><a className="nav-link" href="#sobre-nos">SOBRE NÓS</a></li>
              <li className="nav-item"><a className="nav-link" href="#infraestrutura">INFRAESTRUTURA</a></li>
              <li className="nav-item"><a className="nav-link" href="#servicos">SERVIÇOS</a></li>
              <li className="nav-item"><a className="nav-link" href="#demonstrativos">DEMONSTRATIVOS</a></li>
              <li className="nav-item"><a className="nav-link" href="#eventos">EVENTOS</a></li>
              <li className="nav-item"><a className="nav-link" href="#parcerias">PARCERIAS</a></li>
            </ul>
          </div>
        </div>
      </nav>

      <div id="home" className="hero-section text-white">
        <div className="container text-center">
          <img
            src={images.logo2}
            alt="NovaGenius Logo 2"
            className="img-fluid logo2"
            data-aos="fade-down"
          />

          <div className="d-flex flex-column align-items-center" data-aos="fade-up" data-aos-delay="200">
            <div className="d-flex align-items-center gap-3 mb-3">
              <img src={images.arrow} alt="Seta" className="arrow-icon" />
              <h3 className="fw-bold mb-0">CRESCIMENTO DE VENDAS</h3>
            </div>
            <p className="subtitle mx-auto">
              Spots personalizados e produzidos pela equipe de redação da NovaGenius,
              com anúncios que divulgarão suas ofertas, produtos e
              serviços, reforçando a atenção do cliente presente no
              estabelecimento, induzindo a um aumento de compras por impulso e com
              isso contribuindo em seus números de vendas.
            </p>
          </div>

          <hr className="border-white opacity-75 w-75 mx-auto mb-4" data-aos="zoom-in" data-aos-delay="300" />

          <div className="row text-center icons-home mb-5">
            <div className="col-12 col-md-4 mb-4" data-aos="fade-up" data-aos-delay="400">
              <img src={images.box} alt="Box" className="mb-2 icon-size img-fluid" />
              <p>Promova assuntos internos e externos</p>
            </div>
            <div className="col-12 col-md-4 mb-4" data-aos="fade-up" data-aos-delay="500">
              <img src={images.cloud} alt="Cloud" className="mb-2 icon-size img-fluid" />
              <p>Acervo com milhares de músicas</p>
            </div>
            <div className="col-12 col-md-4 mb-4" data-aos="fade-up" data-aos-delay="600">
              <img src={images.bag} alt="Bag" className="mb-2 icon-size img-fluid" />
              <p>Ótimo para divulgar propagandas pontuais</p>
            </div>
          </div>
        </div>
      </div>

      <div id="sobre-nos" className="tradition-section section py-4">
        <div className="container sound-section">
          <div className="sound-image" data-aos="fade-right">
            <img src={images.sound} alt="Mesa de som" className="img-fluid" />
          </div>
          <div className="text-white text-lg-start tradition-text" data-aos="fade-left">
            <h2 className="fw-bold">TRADIÇÃO É COM A NOVAGENIUS</h2>
            <p>
              Somos pioneiros no segmento de rádio interna, na qual há mais de 40 anos
              lançamos a RÁDIO A CABO no Brasil.<b></b> Estamos no mercado desde 1980
              desenvolvendo conceitos em Music Branding para as principais marcas e
              players do varejo.
            </p>
          </div>
        </div>
      </div>

      <div id="infraestrutura" className="infraestrutura-section py-5 section position-relative">
        <div className="container text-center">
          <h2 className="fw-bold mb-5" data-aos="fade-up">INFRAESTRUTURA</h2>
          <div className="row">
            {/* Adicionado delay sequencial nos cards para efeito "cascata" */}
            <div className="col-12 col-md-3 mb-4" data-aos="fade-up" data-aos-delay="100">
              <div className="infra-card p-4">
                <img src={images.cpu} alt="CPU" className="infra-icon mb-3" />
                <h5>Equipamentos e Softwares</h5>
                <p>Para todas as necessidades</p>
              </div>
            </div>
            <div className="col-12 col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
              <div className="infra-card p-4">
                <img src={images.clock} alt="Clock" className="infra-icon mb-3" />
                <h5>Implementação</h5>
                <p>No prazo de 10 dias</p>
              </div>
            </div>
            <div className="col-12 col-md-3 mb-4" data-aos="fade-up" data-aos-delay="300">
              <div className="infra-card p-4">
                <img src={images.mic} alt="Mic" className="infra-icon mb-3" />
                <h5>Produção</h5>
                <p>De textos, locuções e músicas</p>
              </div>
            </div>
            <div className="col-12 col-md-3 mb-4" data-aos="fade-up" data-aos-delay="400">
              <div className="infra-card p-4">
                <img src={images.settings} alt="Settings" className="infra-icon mb-3" />
                <h5>Suporte Técnico</h5>
                <p>Online e local</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="servicos" className="services-section section">
        <h3 data-aos="fade-down" className="text-center mb-4">SERVIÇOS</h3>
        <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel" data-aos="zoom-in">
          {/* Manter a estrutura atual do seu Carousel */}
          <div className="carousel-inner">
            <div className="carousel-item active">
              <div className="carousel-content carousel-purple d-flex align-items-center">
                <img src={images.radio} className="carousel-image w-50" alt="radio" />
                <div className="carousel-text">
                  <h2>RÁDIO INDOOR</h2>
                  <p>Ideal para a divulgação de ofertas pontuais e reforçar a comunicação com seus clientes e colaboradores...</p>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="carousel-content d-flex align-items-center">
                <img src={images.music_branding} className="carousel-image w-50" alt="music-branding" />
                <div className="carousel-text">
                  <h2>MUSIC BRANDING</h2>
                  <p>Music Branding consiste no estudo e planejamento da identidade musical de uma marca, expressando por meio de ondas sonoras, todos os valores de uma empresa, tornando-a reconhecível pelo público.</p>
                  <p>A NovaGenius conta com mais de 30 anos de experiência na composição de trilhas personalizadas para algumas das mais conceituadas empresas, atuantes nos mais variados segmentos de mercados.</p>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="carousel-content carousel-purple d-flex align-items-center">
                <img src={images.espera_telefonica} className="carousel-image w-50" alt="espera-telefonica" />
                <div className="carousel-text">
                  <h2>ESPERA TELEFÔNICA</h2>
                  <p>Mantenha seu cliente informado sobre as últimas novidades de sua empresa enquanto aguarda para ser atendido, com opções de locuções seja em Português, ou Inglês, produzimos gravações para Espera Telefônica, com fundo musical, em qualquer formato necessário.</p>
                </div>
              </div>
            </div>
            <div className="carousel-item">
              <div className="carousel-content d-flex align-items-center">
                <img src={images.tv_corporativa} className="carousel-image w-50" alt="tv-corporativa" />
                <div className="carousel-text">
                  <h2>TV CORPORATIVA</h2>
                  <p>Os painéis serão utilizados para informar sobre promoções de produtos e marcas próprias, em complemento também para reforçar a marca e produtos de empresas parceiras. A comunicação digital potencializa a experiência do cliente e reduz a percepção do tempo decorrido, além de influenciar o comportamento quando utilizado em filas de espera e checkouts.</p>
                </div>
              </div>
            </div>
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      <div id="demonstrativos" className="demonstrative-section text-white section">
        <div className="container container-demonstrative">
          <h3 className="text-center mb-5" data-aos="fade-up">DEMONSTRATIVOS</h3>
          <div className="row mb-5">
            <div className="col-md-12" data-aos="fade-up" data-aos-delay="200">
              <div className="demonstrative-box p-3 text-center">
                <h3>Demonstrativo 1</h3>
                <p>Vídeo institucional da NovaGenius.</p>
                <div className="media-player">
                  <video controls width="100%">
                    <source src="/videos/institucional.mp4" type="video/mp4" />
                    Seu navegador não suporta vídeos.
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="eventos" className="demonstrative-section text-white section">
        <div className="container container-demonstrative">
          <h3 className="text-center mb-5">EVENTOS</h3>
          <div className="row mb-5">
            <div className=" col-md-12 mt-4">
              <div className="demonstrative-box p-3 text-center">
                <h1><strong>Divulgação Evento Expotel 2026</strong></h1>
                <div className="media-player">
                  <img className="pdf-container" src="/videos/CONDO E EXPOTEL SITE.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mb-5">
          <div className=" col-md-12 mt-4">
            <div className="demonstrative-box p-3 text-center">
              <h1><strong>Divulgação Live 12/02/2026</strong></h1>
              <div className="media-player">
                <img className="pdf-container" src="/videos/live-12-02.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="parcerias" className="demonstrative-section text-white section">
        <h3 className="text-center mb-3" data-aos="fade-up">PARCERIAS</h3>
        <div className="row mb-5" data-aos="fade-up" data-aos-delay="200">
          <div className="div-parceiros col-md-12">
            <a href="https://www.expotel.com.br/" target="_blank" rel="noopener noreferrer">
              <img src={images.logo_parceiro1} alt="Logo Parceiro 1" className="logo-parceiro" />
            </a>
            <a href="https://unimaisedu.com.br/home" target="_blank" rel="noopener noreferrer">
              <img src={images.logo_parceiro2} alt="Logo Parceiro 2" className="logo-parceiro" />
            </a>
          </div>
        </div>
      </div>

      <footer className="footer-bar">
        <div className="footer-container">
          <div className="contact-info">
            <span><FaPhoneAlt /> (11) 2174-2300</span>
            <span><FaWhatsapp /> (11) 97160-0233</span>
            <span><FaEnvelope /> comercial@novagenius.radio.br</span>
          </div>
          <div className="address-info">
            <span><FaMapMarkerAlt /> Rua Conde do Pinhal, 78, Centro, São Paulo - SP, 01501-060</span>
          </div>
        </div>
      </footer>

    </div>
  );
}

export default App;
